import { createSlice } from "@reduxjs/toolkit";
import { addSite, deleteSite, getSites, updateSite } from "../action";

interface Sites {
    _id: string;
    providerName: string;
    providerCode: string;
    siteName: string;
    siteID: number;
    siteCode: string;
    programCostCenterNumber: number;
    st1: string;
    st2: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    phoneNumber: string;
    secondaryPhone: string;
}

interface SitesState {
    sites: Sites[] | any;
    isLoading: boolean
}

const initialState: SitesState = {
    sites: [],
    isLoading: false,
}

export const siteInitialState = createSlice({
    name: 'sites',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(getSites.fulfilled, (state, action) => {
            state.sites = action.payload
            state.isLoading = false;
        })
            .addCase(getSites.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(getSites.rejected, (state, action) => {
                state.isLoading = false
            })
            .addCase(addSite.fulfilled, (state,action)=> {
                state.sites = action.payload
                state.isLoading = false
            })
            .addCase(addSite.pending, (state, action)=> {
                state.isLoading = true
            })
            .addCase(addSite.rejected, (state, action)=> {
                state.isLoading = false
            })
            .addCase(deleteSite.fulfilled, (state,action)=> {
                state.sites = action.payload
                state.isLoading = false
            })
            .addCase(deleteSite.pending, (state, action)=> {
                state.isLoading = true
            })
            .addCase(deleteSite.rejected, (state, action)=> {
                state.isLoading = false
            })
            .addCase(updateSite.fulfilled, (state,action)=> {
                state.sites = action.payload
                state.isLoading = false
            })
            .addCase(updateSite.pending, (state, action)=> {
                state.isLoading = true
            })
            .addCase(updateSite.rejected, (state, action)=> {
                state.isLoading = false
            })
    }
})

export default siteInitialState.reducer